/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import FieldValidator from './field-validator';
import styles from './input-field.scss';
import Eye from '../svg/eye';
import ShutEye from '../svg/shut-eye';
import ErrorMessage from '../error-message/error-message';

export class InputField extends React.Component {

  static propTypes = {
    callback: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    required: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    showErrorWithoutBlur: PropTypes.bool.isRequired,
    classes: PropTypes.string,
    disabled: PropTypes.string,
    errorMessage: PropTypes.string,
    minLength: PropTypes.string,
    maxLength: PropTypes.string,
    validationType: PropTypes.string,
    value: PropTypes.node,
    onKeyUp: PropTypes.func,
    onClick: PropTypes.func,
    showPasswordIcon: PropTypes.bool,
    inputMode: PropTypes.string
  };

  constructor (props) {
    super(props);

    this.state = {
      value: this.props.value ? this.props.value : '',
      valid: false,
      validationType: this.props.validationType,
      type: this.props.type,
      required: this.props.required === 'true',
      minLength: this.props.minLength ? parseInt(this.props.minLength) : 0,
      maxLength: this.props.maxLength ? parseInt(this.props.maxLength) : 0,
      isBlurred: false,
      disabled: this.props.disabled === 'true',
      showErrorWithoutBlur: this.props.showErrorWithoutBlur,
      showPassword: false
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.showPassword = this.showPassword.bind(this);
    this.renderShowPasswordIcon = this.renderShowPasswordIcon.bind(this);
  }

  componentDidMount () {
    this.validate();
  }

  /**
   * Called when user clicks the submit button
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    if (nextProps.showErrorWithoutBlur !== this.props.showErrorWithoutBlur) {
      this.validate();
    }
    if (nextProps.value !== this.props.value) {
      this.setState({
        value: nextProps.value
      });
    }
    if (nextProps.minLength !== this.props.minLength) {
      this.setState({ minLength: nextProps.minLength ? parseInt(nextProps.minLength) : 0 },
        this.validate
      );
    }
    if (nextProps.maxLength !== this.props.maxLength) {
      this.setState({ maxLength: nextProps.maxLength ? parseInt(nextProps.maxLength) : 0 },
        this.validate
      );
    }
    if (nextProps.required !== this.props.required) {
      this.setState({ required: nextProps.required === 'true' },
        this.validate
      );
    }
  }

  onChange (e) {
    this.setState({value: e.target.value}, function () {
      if (!this.state.valid || this.state.isBlurred || this.state.showErrorWithoutBlur) {
        this.validate();
      }
    });
  }

  onBlur () {
    this.setState({isBlurred: true}, function () {
      this.validate();
    });
  }

  validate () {
    var isValid = FieldValidator.validate(this.state);
    this.setState({valid: isValid}, () => {
      this.sendValueToParent();
    });
  }

  /**
   * Send value to parent Component
   */
  sendValueToParent () {
    this.props.callback(this.props.name, {
      value: this.state.value,
      valid: this.state.valid
    });
  }

  shouldShowError () {
    return !this.state.valid && (this.state.isBlurred || this.props.showErrorWithoutBlur);
  }

  showPassword () {
    const showPassword = !this.state.showPassword;
    const type = showPassword ? 'text' : 'password';
    this.setState({
      showPassword: showPassword,
      type: type
    });
  }

  renderShowPasswordIcon () {
    if (this.props.showPasswordIcon) {
      return (
        <span
          className='input-icon'
          onClick={this.showPassword}
        >
          {this.state.showPassword ? <Eye /> : <ShutEye />}
        </span>);
    }
    return null;
  }

  render () {
    var classes, opts;

    classes = 'input-wrapper ' + (this.props.classes || '');
    opts = {};

    if (this.props.disabled === 'true') {
      opts['disabled'] = 'disabled';
    }
    if (this.state.required) {
      opts['required'] = 'required';
    }

    if (this.shouldShowError()) {
      classes += ' ' + styles['validation-error'];
    }

    return (
      <div className={classes}>
        <div className='input-password-container'>
          {this.renderShowPasswordIcon()}
          <input
            type={this.state.type}
            id={this.props.name}
            name={this.props.name}
            value={this.state.value}
            onChange={this.onChange}
            onBlur={this.onBlur}
            onKeyUp={this.props.onKeyUp}
            onClick={this.props.onClick}
            inputMode={this.props.inputMode ? this.props.inputMode : 'text'}
            {...opts} />
          <label htmlFor={this.props.name} placeholder={this.props.placeholder} alt={this.props.placeholder}></label>
        </div>
        <ErrorMessage show={this.shouldShowError()} errorMessage={this.props.errorMessage}/>
      </div>
    );
  }
}

export default InputField;



/** WEBPACK FOOTER **
 ** ./src/components/input-field/input-field.js
 **/